module.exports = __webpack_public_path__ + "img/deces.61ba6892.png";